"use client";

import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const isTopBannerDismissedAtom = atomWithStorage(
  "isTopBannerDismissed",
  false,
);

export const useIsTopBannerDismissed = () => {
  const [isTopBannerDismissed, setIsTopBannerDismissed] = useAtom(
    isTopBannerDismissedAtom,
  );

  return {
    isTopBannerDismissed,
    setIsTopBannerDismissed,
  };
};
